import { controls, currencyToNumber, grouped } from "../../controls";

const col_mon_rp4 = {
  label: "Village wise Statistics",
  starting: true,
  url: "col_mon_rp4",
  pageLabel: "Village Statistics",
  pageType: "history",
  // filteraction: true,
  filter: [


    ...controls.displayText({ tab: "general", label: "Taluka", star: true }),
    ...controls.oc({ tab: "general", c: "Taluka", placeHolder: "Taluka Code", name: "taluka_code", isRequired: true, fastpath: "talukas" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "taluka_display" }),


  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Village wise Statistics",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },
    pivot: true,

    extraRows: {
      location: "top",
      fields: [],
      // grandtotal: { type: "fixed", displayIn: "village_name",val: "GrandTotal","village_count",
      // "saral_count","auto_matched","manual_matched","school_count" count: true },
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "District",
        accessor: "district",
        rwidth: "*"
      },

      {
        Header: "taluka",
        accessor: "taluka",
        rwidth: "*"
      },

      {
        Header: "village",
        accessor: "village_display",
        rwidth: "*"
      },

      {
        Header: "Total village count",
        accessor: "village_count",
        rwidth: "*"
      },

      {
        Header: "total saral count",
        accessor: "saral_count",
        rwidth: "*"
      },

      {
        Header: "total records automatched",
        accessor: "auto_matched",
        rwidth: "*"
      },

      {
        Header: "total records manual match",
        accessor: "manual_matched",
        rwidth: "*"
      },

      {
        Header: "total no. of schools",
        accessor: "school_count",
        rwidth: "*"
      },




    ]
  }
};

export default col_mon_rp4;